export default [
  { id: 'allClear', text: 'AC' },
  { id: 'switchSign', text: '+/-' },
  { id: 'percent', text: '%' },
  { id: 'divide', text: '÷', className: 'operation' },
  { id: 'btn7', text: '7' },
  { id: 'btn8', text: '8' },
  { id: 'btn9', text: '9' },
  { id: 'times', text: 'x', className: 'operation' },
  { id: 'btn4', text: '4' },
  { id: 'btn5', text: '5' },
  { id: 'btn6', text: '6' },
  { id: 'minus', text: '-', className: 'operation' },
  { id: 'btn1', text: '1' },
  { id: 'btn2', text: '2' },
  { id: 'btn3', text: '3' },
  { id: 'plus', text: '+', className: 'operation' },
  { id: 'btn0', text: '0' },
  { id: 'dot', text: '.' },
  { id: 'equals', text: '=', className: 'operation' },
];
